import { useStore } from 'react-redux';
import { selectSessionInfo } from 'services/session/session.selectors';
import { AppChannel } from 'utils/config.config';

export const externalAppId: number[] = [
  AppChannel.AppMobileBingo,
  AppChannel.PlaytechNativePokerApp,
  AppChannel.AppMobileMobileSisalIt,
  AppChannel.AppRouletteGiocaOnLine,
  AppChannel.AppMobileNativeCasinoAppPlaytech,
  AppChannel.MobileLotto10ELotto,
];

export const useIsApp = (): boolean => {
  const reduxStore = useStore();
  const { channel } = selectSessionInfo(reduxStore.getState());
  return channel !== AppChannel.PortaleWebFullResponsiveWwwSisalIt;
};

export const IsExterntalAPP = (): boolean => {
  const reduxStore = useStore();
  const { channel } = selectSessionInfo(reduxStore.getState());
  return (
    channel !== AppChannel.PortaleWebFullResponsiveWwwSisalIt &&
    externalAppId.includes(channel!)
  );
};

export const IsInternallAPP = (): boolean => {
  const reduxStore = useStore();
  const { channel } = selectSessionInfo(reduxStore.getState());
  return (
    channel !== AppChannel.PortaleWebFullResponsiveWwwSisalIt &&
    !externalAppId.includes(channel!)
  );
};

export const useGetSiteId = (): number | undefined => {
  const reduxStore = useStore();
  const { channel } = selectSessionInfo(reduxStore.getState());
  return channel;
};

export const useGetSiteIdParamForExternalRedirect = () => {
  const siteId = useGetSiteId();
  if (!siteId || siteId === 62) return '';
  return `?siteid=${siteId}`;
};
